var exports = {
  "T": "xcc377c0b--adc3a7--colors",
};

module.exports = exports;
